// extracted by mini-css-extract-plugin
export default {"educationContainer":"Education_educationContainer__ZujoY","title":"Education_title__17VxL","subTitle":"Education_subTitle__JtPRC"};